import { LoadingOverlay } from "@mantine/core"
import { RowModel, Table as TanstackTable } from "@tanstack/react-table"
import { Select } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { useBulkUpdateAgecShowMutation } from "~/pages/Brand/Products/List/hooks.ts"

interface Props {
  table: TanstackTable<
    {
      flattenCustomFields: Record<string, string>
      flattenProdsiteFields: Record<string, string>
    } & LibraryResponses.Product
  >
}

export const AgecBulkActions = ({ table }: Props) => {
  const { t } = useTranslation("products")

  const { mutate, isLoading } = useBulkUpdateAgecShowMutation({
    onSuccess: () => {
      table.resetRowSelection()
    },
  })

  function hideSelected(rows: RowModel<LibraryResponses.Product>) {
    const productIds = rows.rows.map((row) => row.original.id)

    mutate({ productIds, agecShow: false })
  }

  function showSelected(rows: RowModel<LibraryResponses.Product>) {
    const productIds = rows.rows.map((row) => row.original.id)

    mutate({ productIds, agecShow: true })
  }

  const rowSelection = table.getSelectedRowModel()

  const bulkActions = [
    {
      label: t("bulkActions.hide", {
        count: rowSelection.rows.length,
      }),
      value: "hide",
      action: hideSelected,
      rowSelection,
    },
    {
      label: t("bulkActions.show", {
        count: rowSelection.rows.length,
      }),
      value: "show",
      action: showSelected,
      rowSelection,
    },
  ]

  return rowSelection.rows.length > 0 ? (
    <>
      <LoadingOverlay visible={isLoading} overlayProps={{ blur: 1 }} />
      <Select
        data={bulkActions}
        onChange={(e) => {
          const action = bulkActions.find((bulk) => bulk.value == e)?.action
          if (action) {
            action(rowSelection)
          }
        }}
        w={180}
        placeholder={t("bulkActions.placeholder")}
        size="xs"
      />
    </>
  ) : null
}
